import employeeApi from "@/api/employee";
import profileApi from "@/api/profile";
import promotionApi from "@/api/promotion";
import moment from "moment";

// initial state
const state = {
  employees: [],
  inactiveEmployees: [],
  detailedEmployee: "",
  detailedEmployeeCurrently: "",
  managersForDetailedEmployee: [],
  primaryPositionsForDetailedEmployee: [],
  baseCertifications: [
    // these need to be gotten from the backend!
    "Certified Staffing Professional",
    "Certified/Licensed/Registered VT",
    "Tech Specialty",
    "DVM License",
    "Board Certification",
    "Driver's License",
    "Race Certification",
    "Program Certification",
    "PLIT"
  ],
  possibleStandings: [
    // these need to be gotten from the backend!
    "Probationary",
    "Part Time",
    "Full Time",
    "Exempt",
    "Seasonal"
  ],
  possibleStatuses: ["Provisional", "Established"],
  possibleAccrualRates: [
    // these need to be gotten from the backend!
    "0.00",
    "0.04",
    "0.06",
    "0.08",
    "0.10"
  ],
  reviews: []
};

const getters = {
  aGetterWithRootState: (state, getters, rootState) => {
    return "a getter with root state";
  },
  mostRecentPromotion: state => {
    if (state.detailedEmployee) {
      let dates = state.detailedEmployee.promotions.map(promo => {
        return moment(promo.date);
      });
      return moment.max(dates);
    }
  },
  employeeCertifications: state => {
    if (state.detailedEmployee) {
      return state.detailedEmployee.certifications.filter(
        c => c.certification_category == "Certification"
      );
      //return state.detailedEmployee.certifications.filter(c => c.certification_category == "Certification" && moment(c.expiration_date).isAfter())
    }
  },
  employeeExpiredCertifications: state => {
    if (state.detailedEmployee) {
      return state.detailedEmployee.certifications.filter(
        c =>
          c.certification_category == "Certification" &&
          moment(c.expiration_date).isBefore()
      );
    }
  },
  employeeInsurances: state => {
    if (state.detailedEmployee) {
      return state.detailedEmployee.certifications.filter(
        c => c.certification_category == "Insurance"
      );
      //return state.detailedEmployee.certifications.filter(c => c.certification_category == "Insurance" && moment(c.expiration_date).isAfter())
    }
  },
  employeeExpiredInsurances: state => {
    if (state.detailedEmployee) {
      return state.detailedEmployee.certifications.filter(
        c =>
          c.certification_category == "Insurance" &&
          moment(c.expiration_date).isBefore()
      );
    }
  }
};

const actions = {
  search({ commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.search(
        params,
        employees => {
          resolve(employees);
        },
        error => {
          console.log("Something broke at the API");
          reject(error);
        }
      );
    });
  },

  getAll({ commit }, userId) {
    employeeApi.getAll(userId, employees => {
      commit("setEmployees", employees);
    });
  },

  getInactiveEmployees({ commit }, userId) {
    employeeApi.getInactiveEmployees(userId, employees => {
      commit("setInactiveEmployees", employees);
    });
  },

  getCurrent({ commit }, userId) {
    employeeApi.getCurrent(userId, status => {
      commit("setDetailedEmployeeCurrently", status);
    });
  },

  clearDetailed({ commit }) {
    commit("setDetailedEmployee", null);
  },

  // Rejects with the axios error (error.response.status is 403 when a client
  // opens an employee not currently assigned to their locations).
  getEmployee({ commit }, employeeId) {
    return new Promise((resolve, reject) => {
      employeeApi.get(
        employeeId,
        employee => {
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => reject(error)
      );
    });
  },

  updateOwnProfile({ commit }, params) {
    return new Promise((resolve, reject) => {
      profileApi.employeeUpdate(
        params,
        profile => {
          resolve(profile);
        },
        error => {
          console.log("Something broke at the API");
          reject(error);
        }
      );
    });
  },

  update({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      employeeApi.update(
        idFieldData,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  savePhoto({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      employeeApi.savePhoto(
        idFieldData,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  saveCertification({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      employeeApi.saveCertification(
        idFieldData,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  addTeams({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.addTeam(
        params,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  deactivate({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.deactivate(
        params.id,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API/store");
          reject();
        }
      );
    });
  },

  reactivate({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.reactivate(
        params.id,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API/store");
          reject();
        }
      );
    });
  },

  managerSetEmployeeProfilePreferences({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.managerOverrideMessagePreferences(
        params,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  pullOffTeams({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.pullOffTeam(
        params,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  removeIneligibleTeams({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.removeIneligibleTeam(
        params,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  addIneligibleTeams({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.addIneligibleTeam(
        params,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  saveNarrativeNotes({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.saveNarrativeNotes(
        params,
        employee => {
          commit("updateEmployee", employee);
          commit("setDetailedEmployee", employee);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  addRemoveSkill({ dispatch, commit }, idSkillAdding) {
    return new Promise((resolve, reject) => {
      if (idSkillAdding.adding) {
        employeeApi.addSkill(
          idSkillAdding,
          employee => {
            commit("updateEmployee", employee);
            commit("setDetailedEmployee", employee);
            resolve();
          },
          error => {
            console.log("Something broke at the API");
            reject();
          }
        );
      } else {
        employeeApi.removeSkill(
          idSkillAdding,
          employee => {
            commit("updateEmployee", employee);
            commit("setDetailedEmployee", employee);
            resolve();
          },
          error => {
            console.log("Something broke at the API");
            reject();
          }
        );
      }
    });
  },

  createPromotion({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      promotionApi.create(
        params,
        promotion => {
          commit("addPromotion", promotion);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  removeERContact({ dispatch, commit }, contactID) {
    return new Promise((resolve, reject) => {
      employeeApi.removeERContact(
        contactID,
        contact => {
          commit("removeContact", contact); // find and remove just this contact from store
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  getManagersForDetailedEmployee({ dispatch, commit }, userID) {
    return new Promise((resolve, reject) => {
      employeeApi.getManagers(
        userID,
        managers => {
          commit("setPossibleManagers", managers);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  getPrimaryPositionsForDetailedEmployee({ dispatch, commit }, userID) {
    return new Promise((resolve, reject) => {
      employeeApi.getPrimaryPositions(
        userID,
        positions => {
          commit("setPossiblePrimaryPositions", positions);
          resolve();
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  },

  getReviews({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.getReviews(
        params,
        reviews => {
          dispatch("setUserReviews", reviews);
          resolve(reviews);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  createReview({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      employeeApi.createReview(
        params,
        review => {
          const message = `Review created!`;
          dispatch(
            "global/showSnackbarSuccess",
            { message: message },
            { root: true }
          );
          commit("refreshReview", review);
          resolve(review);
        },
        error => {
          console.log("Something broke at the API.");
          reject();
        }
      );
    });
  },

  //updateReview ({ dispatch, commit }, idFieldData) {
  //return new Promise((resolve, reject) => {
  //employeeApi.updateNote(idFieldData, note => {
  //commit('refreshReview', review)
  //resolve(review)
  //})
  //})
  //},

  setUserReviews({ commit }, reviews) {
    commit("setUserReviews", reviews);
  },

  refreshReviews({ dispatch, commit }, review) {
    commit("refreshReview", review);
  }
};

const mutations = {
  setEmployees(state, employees) {
    state.employees = employees;
    //state.available = Object.assign({}, state.available, shifts) // Works...
    //Object.assign(state.available, shifts) // NO! doesn't work!
  },

  setInactiveEmployees(state, employees) {
    state.inactiveEmployees = employees;
  },

  setDetailedEmployee(state, employee) {
    state.detailedEmployee = employee;
  },

  setDetailedEmployeeCurrently(state, status) {
    state.detailedEmployeeCurrently = status;
  },

  updateEmployee(state, employee) {
    state.employees = [
      ...state.employees.filter(e => e.id !== employee.id),
      employee
    ];
  },

  addPromotion(state, promotion) {
    state.detailedEmployee.promotions.push(promotion);
  },

  removeContact(state, contact) {
    state.detailedEmployee.emergency_contacts = [
      ...state.detailedEmployee.emergency_contacts.filter(
        c => c.id !== contact.id
      )
    ];
  },

  setPossibleManagers(state, managers) {
    // Filter out deactivated managers for select lists in the UI
    // Specifically for employee admin screen when selecting a manager for an employee
    state.managersForDetailedEmployee = managers.filter(
      manager => manager.deactivated === false
    );
  },

  setPossiblePrimaryPositions(state, positions) {
    state.primaryPositionsForDetailedEmployee = positions;
  },

  setUserReviews(state, reviews) {
    state.reviews = reviews;
  },

  refreshReview(state, review) {
    state.reviews = [...state.reviews.filter(r => r.id !== review.id), review];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
